module.exports = __webpack_public_path__ + "static/img/D4024.52a17551.png";